import {
    USFlag,
    SAFlag,
    INFlag,
    AEDFlag,
    EURFlag,
    GBPFlag,
    BHDFlag,
    KWDFlag,
    QARFlag,
    OMRFlag,
    EGFlag
} from '@assets/svgs/flags'

export const navLinks = [
    { label: 'Flights', href: '/flights' },
    { label: 'Hotels', href: '/hotels' }
    // { label: 'Flight + Hotel', href: '/flights-hotels' }
    // { label: 'Staycations', href: '/staycations' },
    // { label: 'Activities', href: '/activities' }
]

export const languageOptions: { code: string; label: string; Flag: React.ComponentType<any> }[] = [
    { code: 'en', label: 'English', Flag: USFlag },
    { code: 'ar', label: 'العربية', Flag: SAFlag }
]

export const currencyOptions: { code: string; label: string; Flag: React.ComponentType<any>; symbol: string }[] = [
    { code: 'SAR', label: 'Saudi Riyal', Flag: SAFlag, symbol: 'ر.س' },
    { code: 'EGP', label: 'Egyptian Pound', Flag: EGFlag, symbol: '£' },
    { code: 'USD', label: 'US Dollar', Flag: USFlag, symbol: '$' },
    { code: 'INR', label: 'Indian Rupee', Flag: INFlag, symbol: '₹' },
    { code: 'EUR', label: 'Euro', Flag: EURFlag, symbol: '€' },
    { code: 'AED', label: 'UAE Dirham', Flag: AEDFlag, symbol: 'د.إ' },
    { code: 'BHD', label: 'Bahraini Dinar', Flag: BHDFlag, symbol: 'د.ب' },
    { code: 'GBP', label: 'British Pound', Flag: GBPFlag, symbol: '£' },
    { code: 'KWD', label: 'Kuwaiti Dinar', Flag: KWDFlag, symbol: 'د.ك' },
    { code: 'QAR', label: 'Qatar Riyal', Flag: QARFlag, symbol: 'ر.ق' },
    { code: 'OMR', label: 'Oman Riyal', Flag: OMRFlag, symbol: 'ر.ع' }
]
